import { computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import Model, { attr, belongsTo } from '@ember-data/model';

const MAXIMUM_DURATION_TO_RECOMMEND = 30;

export default class CptCodeModel extends Model {
  @attr() description;
  @attr() duration;
  @attr('float') rate;
  @attr('boolean') callToBook;
  @attr() requireCreditCardForNewClients;
  @belongsTo('global-monarch-channel', { async: false, inverse: null }) globalMonarchChannel;
  @equal('requireCreditCardForNewClients', 'unset') isCreditCardRequirementUnset;
  @equal('requireCreditCardForNewClients', 'on') isCreditCardRequired;

  @computed('duration', 'rate')
  get eligibleToRecommend() {
    return !this.rate && this.duration <= MAXIMUM_DURATION_TO_RECOMMEND;
  }
}
